define([
	"jquery",
	"underscore",
	"backbone",
	"models/quote_model",
	"templates/trading/quote_list_item.html"
], function($, _, Backbone, Quote, quoteListTemplate) {
	return Backbone.View.extend({
		el: '#content_layout',

		events:{
			'click #view_all_button' : function(e) {
				this.viewAll = !(this.viewAll);
				this.getQuotes();
				if ( this.viewAll) {
					$('#view_all_button .collapse_txt').show();
					$('#view_all_button .view_all_txt').hide();
				} else {
					$('#view_all_button .collapse_txt').hide();
					$('#view_all_button .view_all_txt').show();
					location.href = "#top_quote";
				}
			},
			'click .account_type': function(e){
				if(e) e.preventDefault();

				var type = $(e.currentTarget).data('type');
				if(type){
					this.$el.find('.ct_listgchild').removeClass('active');
					$(e.currentTarget).addClass('active');

					this.$el.find('.quote_type').removeClass('active');
					this.$el.find('.ct_nav1B li:first-child a').addClass('active');

					this.accountType =  type;
					//	ECN does not have commodity / index
					if ( type.indexOf('ecn') >= 0) {
						$("a[data-type='commodity']").hide();
						$("a[data-type='index']").hide();
					} else {
						$("a[data-type='commodity']").show();
						$("a[data-type='index']").show();
					}
					this.getQuotes();
				}
			},
			'click .quote_type': function(e){
				if(e) e.preventDefault();

				var type = $(e.currentTarget).data('type');
				if(type){
					this.$el.find('.quote_type').removeClass('active');
					$(e.currentTarget).addClass('active');

					this.quoteType = type;
					this.getQuotes();
				}
			},
		},

		initialize: function(){
			this.quoteType = 'forex';
			this.accountType = window.activePromotion;
			if ( this.accountType.indexOf('ecn') >= 0) {
				$("a[data-type='commodity']").hide();
				$("a[data-type='index']").hide();
			}

			this.viewAll = false;

			this.getQuotes();
			this.setTimer();
		},

		// Recursively calling the set timeout makes sure that we don't have two of them running at the same time.
		setTimer: function(){
			var that = this;
			setTimeout(function(){
				$.when(
					that.getQuotes()
				).done(function(){
					that.setTimer();
				});
			}, 1500);
		},

		getQuotes: function(){
			var that = this;
			var quote = new Quote();

			// Return the fetch promise
			return quote.fetch({
				data: {
					'type' : this.quoteType,
					'promotion': this.accountType,
					'need_to_sort' : true,
					't': $.now()
				},
				success: function( model, response, options) {
					that.$('#quote_list').html('');
					var i = 0;
					_.each( model.get('quotes'), function( element, key, list) {
						if ( that.viewAll == false && (i++) > 10) return false;
						that.$('#quote_list').append(quoteListTemplate({ quote: element}));
					});
				},
				error: function( model, response, options) {
				}
			});
		}
	});
});



//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/views/w/trading/spread_view.js
// module id = 55
// module chunks = 0